import vue from '@/main';

import store from "@/store/store.js";
import sso from "../../http/requests/sso/index.js";
import jwt from "../../http/requests/auth/jwt/index.js";

import router from '@/router'

export default {

  // JWT
  loginJWT: function ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt.login(payload.userDetails.email, payload.userDetails.password, payload.remember, payload.recaptchaResponse, payload.ip)
        .then(response => {

          // If there's user data in response
          if (response.data.data.logIn.token) {

            // Set conection
            store.commit('SET_CONNECTION_DATABASE', response.data.data.logIn.user.managed_by_database_connection)
            // Update user details
            store.commit('UPDATE_USER_INFO', response.data.data.logIn.user)

            // Set bearer token in axios
            commit("SET_BEARER", response.data.data.logIn.token)

            if (response.data.data.logIn.user.twofactor_activity && !response.data.data.logIn.user.is_two_factor_validated) {

              router.push('/' + router.currentRoute.params.tenant + '/two-factor')

            } else {
              // Navigate User to homepage
              router.push(router.currentRoute.query.to || '/' + router.currentRoute.params.tenant + '/')
              
            }

            vue.$vs.notify({
              color: 'success',
              title: 'Logado com sucesso!',
              text: 'Você entrou na plataforma com sucesso!'
            })

            resolve(response)
          }
          /*  
                    else {
                      reject({message: "Wrong email or password."})
                    } 
          */
        })
        .catch(error => {
          reject({ error: error, message: "Senha ou E-mail incorreto." })
        })
    })
  },
  loginSSO: function ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      sso.loginSSO(payload.code, payload.redirectUri, payload.ip)
        .then(
          response => {
            if (response.data.data.loginSSO.token) {
              store.commit('SET_CONNECTION_DATABASE', response.data.data.loginSSO.user.managed_by_database_connection)
              store.commit('UPDATE_USER_INFO', response.data.data.loginSSO.user)

              commit("SET_BEARER", response.data.data.loginSSO.token)
              if (response.data.data.loginSSO.user.twofactor_activity && !response.data.data.loginSSO.user.is_two_factor_validated) {
                router.push('/' + router.currentRoute.params.tenant + '/two-factor')
              } else {
                router.push(router.currentRoute.query.to || '/' + router.currentRoute.params.tenant + '/')
              }

              vue.$vs.notify({
                color: 'success',
                title: 'Logado com sucesso!',
                text: 'Você entrou na plataforma com sucesso!'
              })

              resolve(response);
            }
          }
        ).catch(
          error => {
            reject({ error: error, message: "Falha ao Tentar Logar!" })
          }
        )
    });
  },
  integrationLogin: function ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt.integrationLogin(payload.access_token)
        .then(response => {

          // If there's user data in response
          if (response.data.data.integrationLogIn.token) {
            // Update user details
            store.commit('UPDATE_USER_INFO', response.data.data.integrationLogIn.user)

            // Set bearer token in axios
            commit("SET_BEARER", response.data.data.integrationLogIn.token)

            // Navigate User to homepage
            router.push(router.currentRoute.query.to || '/' + router.currentRoute.params.tenant + '/')

            vue.$vs.notify({
              color: 'success',
              title: 'Logado com sucesso!',
              text: 'Você entrou na plataforma com sucesso!'
            })

            resolve(response)
          }
        })
        .catch(error => {
          vue.$vs.notify({
            color: 'danger',
            title: 'Token Incorreto!',
            text: 'Acesse a plataforma com um token válido, ou digite login e senha.'
          })
          reject({ error: error, message: "Senha ou E-mail incorreto." })
        })
    })
  },
  refreshAccessToken({ commit }) {
    return new Promise((resolve) => {
      jwt.refreshToken().then(response => {
        commit("SET_BEARER", response.data.data.refreshToken.token)
        resolve(response.data.data.refreshToken.token)
      })
    })
  },
  disconnected({ commit }, payload) {
    return new Promise((resolve) => {
      jwt.disconnected(payload.ip).then(response => {
        commit("SET_BEARER", response.data.data.disconnected)
        resolve(response.data.data.disconnected)
      })
    })
  },
  verifyPermission({ commit }, verifyPermission) {
    return new Promise((resolve) => {
      jwt.verifyPermission(verifyPermission).then(response => {
        commit("SET_BEARER", response.data.data.verifyPermission)
        resolve(response.data.data.verifyPermission)
      })
      .catch((error) => { reject(error) })
    })
    
  }
}
